import { render, staticRenderFns } from "./personagePage.vue?vue&type=template&id=b67a6634&scoped=true"
import script from "./personagePage.vue?vue&type=script&lang=js"
export * from "./personagePage.vue?vue&type=script&lang=js"
import style0 from "./personagePage.vue?vue&type=style&index=0&id=b67a6634&prod&lang=scss&scoped=true"
import style1 from "./personagePage.vue?vue&type=style&index=1&id=b67a6634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67a6634",
  null
  
)

export default component.exports